import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "pop_up pop_detail",
  id: "find_account",
  style: {"display":"block"}
}
const _hoisted_2 = { class: "content_wrap sign_form" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "checkbox_wrap" }
const _hoisted_5 = { for: "chk1" }
const _hoisted_6 = { class: "btn_wrap" }
const _hoisted_7 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "pop_up_layer find_account",
      style: {"display":"block"},
      onClick: _cache[0] || (_cache[0] = () => {})
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "close_btn",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
      }, [...(_cache[4] || (_cache[4] = [
        _createElementVNode("img", {
          src: "img/close.png",
          alt: "닫기"
        }, null, -1)
      ]))]),
      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "pop_tit" }, [
        _createElementVNode("p", null, "개인정보 수집 및 이용 동의")
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "terms_content custom_scroll",
          innerHTML: $props.content
        }, null, 8, _hoisted_3),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("label", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              id: "chk1",
              type: "checkbox",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.state.isAgree) = $event)),
              ref: "isAgree"
            }, null, 512), [
              [_vModelCheckbox, $setup.state.isAgree]
            ]),
            _cache[5] || (_cache[5] = _createElementVNode("em", null, null, -1)),
            _cache[6] || (_cache[6] = _createElementVNode("span", null, "동의합니다.", -1))
          ]),
          _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            class: _normalizeClass(["submit_btn", { _gray: !$setup.state.isAgree }]),
            disabled: !$setup.state.isAgree,
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.callback && $setup.callback(...args)))
          }, "확인", 10, _hoisted_7)
        ])
      ])
    ])
  ], 64))
}